export default "__VITE_ASSET__ccf80fe9__"